var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlightlySmiling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 28.1905C22.7329 28.1905 28.1908 22.7327 28.1908 16.0001C28.1908 9.26745 22.7329 3.80957 16.0003 3.80957C9.26768 3.80957 3.80981 9.26745 3.80981 16.0001C3.80981 22.7327 9.26768 28.1905 16.0003 28.1905Z",
    fill: "url(#paint0_radial_179_8997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.0003 28.1905C22.7329 28.1905 28.1908 22.7327 28.1908 16.0001C28.1908 9.26745 22.7329 3.80957 16.0003 3.80957C9.26768 3.80957 3.80981 9.26745 3.80981 16.0001C3.80981 22.7327 9.26768 28.1905 16.0003 28.1905Z",
    fill: "url(#paint1_radial_179_8997)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3182 9.68396C13.3182 9.19636 12.7924 8.8916 11.8782 8.8916C11.1086 8.8916 9.4096 9.31824 8.24388 10.8192C8.03056 11.0935 8.35816 11.2459 8.57148 11.0706C9.28768 10.4611 11.2153 9.67636 12.7162 9.84396C13.3182 9.90492 13.3182 9.68396 13.3182 9.68396Z",
    fill: "url(#paint2_linear_179_8997)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0156 15.6037C12.6636 15.6037 13.189 14.8089 13.189 13.8285C13.189 12.848 12.6636 12.0532 12.0156 12.0532C11.3676 12.0532 10.8423 12.848 10.8423 13.8285C10.8423 14.8089 11.3676 15.6037 12.0156 15.6037Z",
    fill: "url(#paint3_radial_179_8997)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0156 12.6551C12.5185 12.6551 12.9604 13.097 13.189 13.7447C13.1737 12.7847 12.6556 12.0151 12.0156 12.0151C11.3756 12.0151 10.8575 12.7847 10.8423 13.7447C11.0708 13.097 11.5128 12.6551 12.0156 12.6551Z",
    fill: "url(#paint4_linear_179_8997)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6821 9.68396C18.6821 9.19636 19.2079 8.8916 20.1222 8.8916C20.8917 8.8916 22.5907 9.31824 23.7565 10.8192C23.9698 11.0935 23.6422 11.2459 23.4288 11.0706C22.7127 10.4611 20.785 9.67636 19.2841 9.84396C18.6745 9.90492 18.6821 9.68396 18.6821 9.68396Z",
    fill: "url(#paint5_linear_179_8997)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3868 19.5659C21.2877 19.5506 21.1811 19.5811 21.1125 19.6497C19.802 20.8763 17.7829 21.5392 16.2591 21.5392H16.0001H15.7411C14.2173 21.5392 12.1982 20.8763 10.8877 19.6497C10.8115 19.5811 10.7125 19.5506 10.6134 19.5659C10.5068 19.5887 10.4534 19.703 10.5068 19.7944C11.6268 21.7297 13.6915 22.9259 15.9391 22.9259H16.0077H16.0763C18.3239 22.9259 20.3887 21.7297 21.5087 19.7944C21.5468 19.703 21.4934 19.5887 21.3868 19.5659Z",
    fill: "#643800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9773 15.6037C20.6253 15.6037 21.1506 14.8089 21.1506 13.8285C21.1506 12.848 20.6253 12.0532 19.9773 12.0532C19.3293 12.0532 18.804 12.848 18.804 13.8285C18.804 14.8089 19.3293 15.6037 19.9773 15.6037Z",
    fill: "url(#paint6_radial_179_8997)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9773 12.6551C19.4744 12.6551 19.0326 13.0971 18.804 13.7447C18.8192 12.7847 19.3373 12.0151 19.9773 12.0151C20.6173 12.0151 21.1354 12.7847 21.1506 13.7447C20.9221 13.0971 20.4802 12.6551 19.9773 12.6551Z",
    fill: "url(#paint7_linear_179_8997)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3868 19.5659C21.2877 19.5506 21.1811 19.5811 21.1125 19.6497C19.802 20.8763 17.7829 21.5392 16.2591 21.5392H16.0001H15.7411C14.2173 21.5392 12.1982 20.8763 10.8877 19.6497C10.8115 19.5811 10.7125 19.5506 10.6134 19.5659C10.5068 19.5887 10.4534 19.703 10.5068 19.7944C10.5144 19.8173 10.5296 19.8325 10.5449 19.8477C10.6515 19.7868 10.7658 19.7259 10.8801 19.8554C12.122 21.2497 13.9658 22.0877 15.9391 22.0877H16.0077H16.0763C18.0649 22.0877 19.9163 21.2421 21.1582 19.8249C21.2725 19.6954 21.3791 19.7563 21.4782 19.8249C21.4858 19.8097 21.4934 19.8021 21.5011 19.7868C21.5468 19.703 21.4934 19.5887 21.3868 19.5659Z",
    fill: "url(#paint8_linear_179_8997)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_179_8997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5988 11.0597) scale(14.7062 14.7062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_179_8997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5988 11.0596) scale(11.57 11.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_8997",
    x1: 10.7446,
    y1: 10.501,
    x2: 10.7446,
    y2: 9.21652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_179_8997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6652 13.8788) rotate(73.8539) scale(1.72242 1.11438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_8997",
    x1: 12.0173,
    y1: 12.0463,
    x2: 12.0173,
    y2: 13.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_179_8997",
    x1: 21.2497,
    y1: 10.501,
    x2: 21.2497,
    y2: 9.21652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_179_8997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6255 13.8791) rotate(73.8539) scale(1.72242 1.11438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_179_8997",
    x1: 19.9772,
    y1: 12.0464,
    x2: 19.9772,
    y2: 13.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_179_8997",
    x1: 15.9971,
    y1: 20.4275,
    x2: 15.9971,
    y2: 22.2474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightlySmiling);
export default __webpack_public_path__ + "static/media/SlightlySmiling.e629940e0154f77f310da084877c12e9.svg";
export { ForwardRef as ReactComponent };